import * as React from 'react'
import { observer } from 'mobx-react'
import { ProPayoutsViewModel } from '../../ProPayoutsViewModel'
import { useScrollOffsetSpring } from 'hooks/spring-hooks'
import {
  StickyViewHeader,
  StickyViewHeaderMain,
} from 'components/StickyViewHeader'
import { Sandwich, SandwichBun, SandwichContent } from 'components/Sandwich'
import { ViewHeading } from 'components/ViewHeading'
import { ContentLayout, ContentMain } from 'components/ContentLayout'
import ListHeader from 'components/ListHeader'
import { useActivation } from 'hooks/mobx-hooks'
import ProHistoricalTransactionsTable from './ProHistoricalTransactionsTable'
import PayoutSummary from './PayoutSummary'
import SidebarTip from './SidebarTip'
import ContentLoading from 'components/ContentLoading'
import ContentError from 'components/ContentError'

interface ProPayoutsViewProps {
  vm: ProPayoutsViewModel
}

/**
 * The ProPayoutsView
 */
export default observer(function ProPayoutsView({ vm }: ProPayoutsViewProps) {
  const scrollRef = React.useRef<HTMLDivElement | null>(null)
  const scrollOffset = useScrollOffsetSpring(scrollRef)
  useActivation(vm)
  return vm.prepare.match({
    pending: () => <ContentLoading />,
    rejected: (err) => <ContentError error={err} />,
    resolved: () => {
      if (!vm.canView) {
        return <ContentError error="You are not allowed to view this page" />
      }

      return (
        <Sandwich stretch>
          <SandwichBun>
            <StickyViewHeader scrollOffset={scrollOffset}>
              <StickyViewHeaderMain>
                <ViewHeading primaryText="Payouts" secondaryText="Earnings" />
              </StickyViewHeaderMain>
            </StickyViewHeader>
          </SandwichBun>
          <SandwichContent stretch>
            <ContentLayout accountForLabel fill ref={scrollRef}>
              <ContentMain fill constrainWidth>
                <Sandwich stretch>
                  <SandwichBun>
                    <ListHeader>Analytics</ListHeader>
                    <PayoutSummary vm={vm} />
                    <ListHeader count={vm.transactionsCount || undefined}>
                      Transaction history
                    </ListHeader>
                  </SandwichBun>
                  <SandwichContent stretch>
                    <ProHistoricalTransactionsTable vm={vm} />
                  </SandwichContent>
                </Sandwich>
              </ContentMain>
              <SidebarTip />
            </ContentLayout>
          </SandwichContent>
        </Sandwich>
      )
    },
  })
})
